import type { ClientMetadata, HandshakeResult, TopicName } from 'magpie-types';
import type { MessagingProxy } from './messaging-proxy';
import { Unsubscribe } from '../types';

export interface IConnectionStrategy {
  open(): Promise<MessagingProxy>;
  close(): Promise<void>;
  getHandshakeResult(): HandshakeResult | null;
  getActiveTopicSubscriptions(): Promise<ReadonlyArray<TopicName>>;
  onTopicSubscriptionsChange: (
    onChange: (topics: ReadonlyArray<TopicName>) => void
  ) => Unsubscribe;
}

export interface ConnectionOptions {
  clientMetadata: ClientMetadata;
  debug: boolean;
  forceReload?: boolean;
}

export abstract class AbstractConnectionStrategy
  implements IConnectionStrategy
{
  protected handshakeResult: HandshakeResult | null = null;
  public abstract readonly name: string;

  constructor(protected readonly options: ConnectionOptions) {}

  public abstract open(): Promise<MessagingProxy>;

  public abstract close(): Promise<void>;

  public abstract getHandshakeResult(): HandshakeResult | null;

  public abstract getActiveTopicSubscriptions(): Promise<
    ReadonlyArray<TopicName>
  >;

  public abstract onTopicSubscriptionsChange: (
    onChange: (topics: readonly string[]) => void
  ) => Unsubscribe;
}
